import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

@Injectable({ providedIn: 'root' })
export class GetPageDataGqlService {
  readonly document = gql`
    query GetPageData {
      pagesSetup(orderBy: order_ASC) {
        name
        title
        text
        sidebarTitle
        url
        order
      }
    }
  `;
}
